import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCartH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30.5 61a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 2a6 6 0 1 0 0-12 6 6 0 0 0 0 12M52.5 61a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 2a6 6 0 1 0 0-12 6 6 0 0 0 0 12M6.5 9a1 1 0 0 1 1-1h5.338a4 4 0 0 1 3.795 2.735l9.948 29.846A5 5 0 0 0 31.325 44h21.517a5 5 0 0 0 4.682-3.244l5.26-14.027C63.642 24.44 61.95 22 59.507 22H28.5a1 1 0 1 1 0-2h31.007c3.84 0 6.498 3.836 5.15 7.431l-5.26 14.027A7 7 0 0 1 52.841 46H31.325a7 7 0 0 1-6.641-4.786l-9.949-29.846A2 2 0 0 0 12.838 10H7.5a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  }));
}
var IcCartH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCartH72));

export { IcCartH72 as I };
